var viewer_rtlignore_default = {
  "gallery_container": "khlpD",
  "imageTitleContainer": "gO-Ot",
  "clickableItem": "_3jKKH",
  "prerender": "dyJ4c",
  "expandButton": "ylSUX",
  "itemContainer": "Bb90C",
  "expandIcon": "TqWZ8",
  "itemOverlay": "a2VGH",
  "imageTitle": "T8qNj",
  "pointer": "ywd7J",
  "fadeIn": "W3Y-P",
  "changing_background": "XeZzt"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
